import React, { ReactNode } from 'react';
import { HorizontalLine } from '../../../../../components/HorizontalLine';
import Radio from '../../../../../components/Radio';
import { Unit } from '../../../../../components/ServiceItem';
import { unitWorkDaysString } from '../../../../../utils/dates';

import { CardContainer, ClosestDate, Column, RadioColumn, Row, Subtitle, Title } from './styles';

interface UnitCardProps {
  location: Unit;
  isChecked: boolean;
  closestDateAvailable: string;
  isOpenToSchedule: boolean;
  onLocationSelected: (location: Unit) => void;
  showRadio?: boolean;
}

const buildUnitWorkDays = (unit: Unit): ReactNode => {
  return unitWorkDaysString(unit).reduce((previous, text, index) => {
    if (index === 0) {
      return <span>{text}</span>;
    }
    return (
      <>
        {previous}
        <br />
        <span>{text}</span>
      </>
    );
  }, <></>);
};

export const UnitCard: React.FC<UnitCardProps> = ({
  location,
  isChecked,
  closestDateAvailable,
  isOpenToSchedule,
  onLocationSelected,
  showRadio
}) => {
  const isUnavailable = isOpenToSchedule && !closestDateAvailable;
  return (
    <CardContainer onClick={() => !isUnavailable && onLocationSelected(location)}>
      <Column isUnavailable={isUnavailable}>
        <Row>
          <Column>
            <Title>{location.name}</Title>
            <Subtitle>
              <span>{`${location.address}, ${location.address_number}`}</span>
              <br />
              <span>
                {`${location.neighborhood}, ${location.address_complement ? location.address_complement + ', ' : ''} ${
                  location.city + ' - ' + location.state
                }`}
              </span>
            </Subtitle>
          </Column>
          <RadioColumn>
            {showRadio && <Radio id={location.id} isChecked={!isUnavailable ? isChecked : false} />}
          </RadioColumn>
        </Row>
        <HorizontalLine />
        {isOpenToSchedule ? (
          <ClosestDate>{!isUnavailable ? `Data mais próxima: ${closestDateAvailable}` : 'Indisponível'}</ClosestDate>
        ) : (
          location.business_unit_work_hour && <ClosestDate>{buildUnitWorkDays(location)}</ClosestDate>
        )}
      </Column>
    </CardContainer>
  );
};
